export enum SpecialFixedTemplateSearchTypes {
    CustomerId = "CustomerId",
    CustomerName = "CustomerName",
    ItemNumber = "ItemNumber",
    ContractNumber = "ContractNumber",
    ContractName = "ContractName",
    TemplateId = "TemplateId"
};
